
























import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
@Component
export default class UIActions extends Vue {
  @Prop(Array) readonly selected: object[];
  fab = true;
}
